import { IsAllow } from './portfolio';
import {
    Bank_New,
    NewPurchasePayload,
    PaymentTypes,
    SchemeOptionType,
} from '../../components/dashboard/commercial/ExploreMFs/types';
import { string } from 'yup/lib/locale';
import { RTA_CODES } from '../../components/dashboard/commercial/emandate/types';

export const GET_PURCHASE_DETAILS = 'GET_PURCHASE_DETAILS';
export const GET_PURCHASE_DETAILS_SUCCESS = 'GET_PURCHASE_DETAILS_SUCCESS';
export const UPDATE_PURCHASE_INFO = 'UPDATE_PURCHASE_INFO';
export const CLEAR_PURCHASE_INFO = 'CLEAR_PURCHASE_INFO';
export const SET_PURCHASE_INFO = 'SET_PURCHASE_INFO';

export const GET_PURCHASE_SCHEME_DETAILS = 'GET_PURCHASE_SCHEME_DETAILS';
export const GET_PURCHASE_SCHEME_DETAILS_SUCCESS = 'GET_PURCHASE_SCHEME_DETAILS_SUCCESS';
export const GET_PURCHASE_SCHEME_DETAILS_FAILED = 'GET_PURCHASE_SCHEME_DETAILS_FAILED';

export const GET_MASTER_DATA = 'GET_MASTER_DATA';
export const GET_MASTER_DATA_SUCCESS = 'GET_MASTER_DATA_SUCCESS';
export const SET_SCHEME_INFO = 'SET_SCHEME_INFO';
export const RESET_SCHEME_INFO = 'RESET_SCHEME_INFO';
export const SET_SCHEME_PLAN = 'SET_SCHEME_PLAN';
export const CLEAR_SCHEME_INFO = 'CLEAR_SCHEME_INFO';
export const SET_FOLIO_PURCHASE_TYPE = 'SET_FOLIO_PURCHASE_TYPE';
export const SET_SIP_OR_LUMPSUM = 'SET_SIP_OR_LUMPSUM';
export const CLEAR_SIP_OR_LUMPSUM = 'CLEAR_SIP_OR_LUMPSUM';
export const NEW_PURCHASE = 'NEW_PURCHASE';
export const NEW_PURCHASE_SUCCESS = 'NEW_PURCHASE_SUCCESS';
export const VALIDATE_ARN = 'VALIDATE_ARN';
export const VALIDATE_ARN_SUCCESS = 'VALIDATE_ARN_SUCCESS';
export const GET_OTM_DETAILS = 'GET_OTM_DETAILS';
export const GET_OTM_DETAILS_SUCCESS = 'GET_OTM_DETAILS_SUCCESS';
export const CHECK_ONLINE_PAYMENT_MODE = 'CHECK_ONLINE_PAYMENT_MODE';

export const PROSPECT_FOLIO = 'PROSPECT_FOLIO';
export const PROSPECT_FOLIO_SUCCESS = 'PROSPECT_FOLIO_SUCCESS';
export const PERFORM_PENNY_DROP = 'PERFORM_PENNY_DROP';
export const PENNY_DROP_SUCCESS = 'PENNY_DROP_SUCCESS';

export const TRANSACTION_PAY_ONLINE = 'TRANSACTION_PAY_ONLINE';
export const TRANSACTION_PAY_ONLINE_SUCCESS = 'TRANSACTION_PAY_ONLINE_SUCCESS';
export const TRANSACTION_PAY_ONLINE_FAILED = 'TRANSACTION_PAY_ONLINE_FAILED';

export const GET_PAYMENT_STATUS = 'GET_PAYMENT_STATUS';
export const GET_PAYMENT_STATUS_SUCCESS = 'GET_PAYMENT_STATUS_SUCCESS';
export const GET_PAYMENT_STATUS_FAILED = 'GET_PAYMENT_STATUS_FAILED';

export const GET_EKYC_NEW_STATUS = 'GET_EKYC_NEW_STATUS';
export const GET_EKYC_NEW_STATUS_SUCCESS = 'GET_EKYC_NEW_STATUS_SUCCESS';
export const GET_EKYC_NEW_STATUS_FAILED = 'GET_EKYC_NEW_STATUS_FAILED';

export const SET_EUIN_CHECKED = 'SET_EUIN_CHECKED';

export const GET_OTM_BANK_DETAILS = 'GET_OTM_BANK_DETAILS';
export const GET_OTM_BANK_DETAILS_SUCCESS = 'GET_OTM_BANK_DETAILS_SUCCESS';
export const GET_OTM_BANK_DETAILS_FAILED = 'GET_OTM_BANK_DETAILS_FAILED';

export const GET_BANK_DETAILS = 'GET_BANK_DETAILS';
export const GET_BANK_DETAILS_SUCCESS = 'GET_BANK_DETAILS_SUCCESS';
export const GET_BANK_DETAILS_FAILED = 'GET_BANK_DETAILS_FAILED';

export const REGISTER_NEW_OTM = 'REGISTER_NEW_OTM';
export const REGISTER_NEW_OTM_SUCCESS = 'REGISTER_NEW_OTM_SUCCESS';
export const REGISTER_NEW_OTM_FAILED = 'REGISTER_NEW_OTM_FAILED';

export type OtmAllowedBankAPIReq = {
    rtaCode: RTA_CODES;
};

export type GetAllowedBanksRequest = {
    amc: string;
    reqId: string | '';
};

export type OtmBankAllowedData = {
    ifscPrefixCode: string;
    bankName: string;
    rtaCode: RTA_CODES;
};

export type OtmAllowedBankAPIResponse = {
    data: OtmBankAllowedData[];
};

export type schemeType = {
    userTrxnNo: string;
    itemNo: string;
    folio: string;
    isin: string;
    reInvest: string;
    trxnDate: string;
    trxnTime: string;
    amount: string;
    trxnType: string;
    distId?: string;
    subDist?: string;
    subBrokerARN?: string;
    euin?: string;
    euinDeclarationFlag: IsAllow | string;
    riaCode?: string;
    startDate: string;
    endDate: string;
    registrationDate?: string;
    registrationAmount?: string;
    frequency?: string;
    noOfInstallments?: string;
    sipType?: string;
    minSipTat?: string;
    maxSipTat?: string;
    riaFlag?: string;
};

export enum Risks {
    'Low' = '1',
    'Medium' = '2',
    'High' = '3',
    'Principal at low risk' = '4',
    'Principal at moderately low risk' = '5',
    'Principal at moderate risk' = '6',
    'Principal at moderately high risk' = '7',
    'Principal at high risk' = '8',
    'Principal at very high risk' = '9',
    'Principal at low to moderate risk' = '10',
}

export enum Categories {
    Equity = 'Equity',
    Debt = 'Debt',
    Hybrid = 'Hybrid',
    Solution_Oriented = 'Solution Oriented',
    Other = 'Other',
}

export enum FundSizes {
    'Below 100' = 1,
    '100 - 200',
    '200 - 300',
    '300 - 500',
    '500 - 1000',
    'More than 1000',
}

export type SubCatergoryType = {
    subcategoryId: string;
    subcategoryName: string;
};
export type CategoryFeedType = {
    categoryId: Categories;
    categoryName: string;
    subcategory: SubCatergoryType[];
};
export type FundSizesFeedType = {
    name: string;
    id: FundSizes;
};
export type RiskCategoriesFeedType = {
    name: string;
    risk: string;
    id: Risks;
};

export type MasterDataType = {
    unSortedAmcList: any[];
    amcDetails: any[];
    categories: CategoryFeedType[];
    fundSizes: FundSizesFeedType[];
    riskCategories: RiskCategoriesFeedType[];
};

export type OtmPayload = {
    // trxnType: PaymentTypes,
    amc: string;
    // folio?: string
    // amount: string,
    // fromDate?: string,
    // toDate?: string
};

export enum ResponseStatus {
    NOT_INTIATED,
    PENDING,
    DONE,
    FAILED,
}

export type PaymentStausApiRequestType = {
    reqId: string;
};

export enum PaymentStatusCodes {
    PENDING_FOR_PAYMENT = 1,
    SUCCESS,
    PAYMENT_NOT_ACCEPTED,
    PENDING_FROM_BANK,
    NOT_PROCESS,
    VALID_UPI,
    DECLINE_UPI,
    CANCELLED,
    MANDATE_PENDING,
    MANDATE_REG_SUCCESS = 11,
    MANDATE_REG_FAILED = 12,
    BACKEND_ERROR = 500,
}
export type PaymentStatusResponse = {
    reqId: string;
    status: string;
    statusCode: PaymentStatusCodes;
};

type OtmTrxnDataType = {
    amc: string | number;
    paymentDetails: [
        {
            folio: string;
            isin: string;
            userTrxnNo: string;
            instNo: string;
            instDateTime: string;
            omUMRN: string;
            mandateRefId: string;
            payInMech: string;
            otmType: string;
            bankCode: string;
            status: 'SUCCESS';
            errorDescription: string;
            paymentGatewayRequest: string;
        },
    ];
};

export type OtmTrxnRequestType = {
    data: OtmTrxnDataType[];
    reqId: string;
};

export type AdditionalPurchaseRequestType = Omit<NewPurchasePayload, 'investorDetails'> & {
    bank: Bank_New;
};
